export enum AgentLanguage {
  ITALIAN = 'it',
  ENGLISH = 'en',
  FRENCH = 'fr'
}
